import { render, staticRenderFns } from "./addSignRule.vue?vue&type=template&id=2822fcc2"
import script from "./addSignRule.vue?vue&type=script&lang=js"
export * from "./addSignRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports